import { capitalize } from 'helper-functions-library';
import { apiFetchWithErrorCheck } from '../functions/apiFetchv4/apiFetch.js';
import { pluralConcepts } from '../functions/pluralConcepts/pluralConcepts.js';
import { ErrorBoundary } from 'component-library';
import { ConceptDisplay } from './ConceptDisplay.js';
//various componets and functions brought in for use
const { render, useState, useEffect } = wp.element;

export function FrontEndDisplay(props) {

	//get the information from the url. Get each segment of the url and place into a array, then pull the information into variables
	let segmentStr = decodeURI(decodeURI(window.location.pathname)), // returns segment1/segment2/segment3/segment4
		segmentArray = segmentStr.split( '/' ),//convert the url to array
		name = decodeURIComponent(segmentArray[ segmentArray.length - 2 ]),//only for categories, others are ids
		type = segmentArray[ segmentArray.length - 3 ];

	const [state, setState] = useState();

	//run once on creation
	useEffect(() => {
		let field = type+'_unique_id';
		
		if (type == 'category') {
			field = type;
		}
		
		apiFetchWithErrorCheck({ 
			action:'get_'+type+'_linked_results',
			nounce: framework_info.nounce,
			data: {
				_framework_ids:[parseInt(framework_info.id_framework)], 
				_condition_group:{
					_conditions:[
						{ _condition: {_table:'rf_'+type, _field:field, _operator_and_value:{_value:name, _operator:'='}} },
					],
					_condition_group_operator:'AND',
				}, 
			}
		}).then( 
			(response) =>  {
				let result = response['results'][0][0];
				
				['strategy', 'question', 'category'].forEach((i)=> {
					if (i == type) { //skip this type
						return;
					}
					if (typeof result?.[i] == 'string') {
						result[i] = JSON.parse(result[i]);
					}
				});

				setState(result);
			}
		)
		.catch((error) => {
			console.log(error);
		});
  	}, []);

	if (state == undefined) {
		return <p>{name}: {type} not found.</p>;
	}

	if (type == 'question' || type == 'strategy') {
		let localNumber = '';
		if( state[type+'_local_numbering'] !== undefined && state[type+'_local_numbering'] !== '') {
			localNumber = state[type+'_local_numbering']+' - ';
		}

		return <>
			<h3 className="resf-concept-title">{capitalize(type)}: {localNumber}{capitalize(state[type] ?? '')}</h3>
			<ConceptDisplay
				concept={type} 
				data={state}
			/>
		</>;
	} 
	
	if (type == 'category') {

		let conceptPresentation = ['question', 'strategy'].map((concept) => { 
			let filtered = state[concept].map((item)=>{
						if (item[concept] == undefined ) {
							return null;
						}
					return item;
				}).filter(n=>n);
				
			if (filtered.length == 0 ) {
				return;
			}
			return <>
				<h3 className="resf-concept-title">{capitalize(pluralConcepts(concept))} tagged with this category </h3>
				<ul>{
					filtered.map((item)=>{
						return <li>
							<a href={framework_info.homeURL+'/researchframework/v1/'+concept+'/'+encodeURIComponent(encodeURIComponent(item[[concept]+'_unique_id']))} > 
								{item[concept]} 
							</a>
						</li>
					})
				}</ul>
			</>;
		});

		return <>
			<h2 className="resf-concept-title">{capitalize(type)}: {capitalize(state.category)}</h2>
			<details>
				<summary>More Information on this category</summary>
				<h5 className="resf-concept-more-info-sub-header" >Owner: </h5>
				<span className="resf-concept-more-info-sub-content">{state.category_owner} </span>
				<h5 className="resf-concept-more-info-sub-header" >Owner url: </h5>
				<span className="resf-concept-more-info-sub-content"><a href={state.category_owner_url}>{state.category_owner_url}</a> </span>
				<h5 className="resf-concept-more-info-sub-header" >Category URI: </h5>
				<span className="resf-concept-more-info-sub-content"><a href={state.category_uri}>{state.category_uri}</a> </span>
			</details>
			{conceptPresentation}
		</>;
	}
}

if ( document.readyState === "complete" || (document.readyState !== "loading" && !document.documentElement.doScroll) ) {
	callback();
} else {
	document.addEventListener("DOMContentLoaded", function(){
		render(<ErrorBoundary><FrontEndDisplay /></ErrorBoundary>, document.getElementById(`rf-display`));
	});
}